<template lang="pug">
.frame-decor(:class="getClassName")
  .frame-decor__inner(:class="getInnerClassName")
    slot
</template>

<script>
export default {
  name: "FrameDecor",

  props: {
    isTransparent: {
      type: Boolean,
      default: true,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    fillsContainer: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getClassName() {
      return [
        !this.isTransparent ? "frame-decor__notransparent" : "",
        this.fillsContainer ? "frame-decor__fills-container" : "",
      ];
    },
    getInnerClassName() {
      return [!this.hasBorder ? "no-border" : ""];
    },
  },
};
</script>
<style lang="scss">
@import "../style/frame.scss";
</style>
